<template>
  <div>
    <Head title="Crear cliente" />
    <div class="flex items-center gap-4 mb-8">
      <button 
        class="btn-secondary flex items-center gap-2" 
        @click="back"
        :disabled="form.processing"
      >
        <i class="fa fa-arrow-left" />
        Volver
      </button>
      <h1 class="text-3xl font-bold flex items-center gap-2">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Clientes</Link>
        <span class="text-indigo-400 font-medium">/</span>
        <span>Crear</span>
      </h1>
    </div>

    <div class="max-w-3xl bg-white rounded-xl shadow overflow-hidden">
      <form @submit.prevent="handleSubmit">
        <div class="p-8 space-y-8">
          <!-- Basic Information Section -->
          <div>
            <h2 class="text-lg font-semibold mb-4">Información Básica</h2>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <text-input
                v-model="form.companyName"
                :error="form.errors.companyName"
                label="Empresa"
                :disabled="form.processing"
              />
              <text-input
                v-model="form.name"
                :error="form.errors.name"
                label="Nombre y Apellido"
                required
                :disabled="form.processing"
              />
            </div>
          </div>

          <!-- Contact Information Section -->
          <div>
            <h2 class="text-lg font-semibold mb-4">Información de Contacto</h2>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <text-input
                v-model="form.email"
                :error="form.errors.email"
                label="Correo electrónico"
                type="email"
                :disabled="form.processing"
              />
              <text-input
                v-model="form.phone"
                :error="form.errors.phone"
                label="Teléfono"
                type="tel"
                :disabled="form.processing"
              />
              <text-input
                v-model="form.identification"
                :error="form.errors.identification"
                label="Cédula o RIF"
                required
                :disabled="form.processing"
              />
              <text-input
                v-model="form.address"
                :error="form.errors.address"
                label="Dirección"
                :disabled="form.processing"
              />
            </div>
          </div>

          <!-- Classification Section -->
          <div>
            <h2 class="text-lg font-semibold mb-4">Clasificación</h2>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div>
                <label class="form-label" for="typeClient">Tipo de cliente</label>
                <select 
                  id="typeClient"
                  v-model="form.typeClient" 
                  class="form-input mt-2 w-full"
                  :disabled="form.processing"
                  required
                >
                  <option value="">Seleccionar</option>
                  <option value="freelancer">Freelancer</option>
                  <option value="spot">SPOT</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                </select>
                <div v-if="form.errors.typeClient" class="form-error">{{ form.errors.typeClient }}</div>
              </div>

              <div v-if="auth.user.role == 'supersales' || auth.user.role == 'admin'">
                <label class="form-label" for="responsable_id">Vendedor</label>
                <select 
                  id="responsable_id"
                  v-model="form.responsable_id" 
                  class="form-input mt-2 w-full"
                  :disabled="form.processing"
                >
                  <option value="">Seleccionar</option>
                  <option 
                    v-for="vendor in vendors" 
                    :key="vendor.id" 
                    :value="vendor.user.id"
                  >
                    {{vendor.user.first_name}} {{vendor.user.last_name}}
                  </option>
                </select>
                <div v-if="form.errors.responsable_id" class="form-error">{{ form.errors.responsable_id }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button 
            :loading="form.processing" 
            class="btn-primary"
            type="submit"
          >
            Crear cliente
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'CreateClient',
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    auth: {
      type: Object,
      required: true
    },
    organizations: {
      type: Array,
      required: true
    },
    vendors: {
      type: Object,
      required: true
    }
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        companyName: '',
        name: '',
        email: '',
        identification: '',
        phone: '',
        address: '',
        typeClient: '',
        responsable_id: ''
      }),
    }
  },
  methods: {
    back() {
      window.history.back()
    },
    async handleSubmit() {
      try {
        await this.form.post('/clients')
      } catch (error) {
        console.error('Error creating client:', error)
      }
    },
  },
}
</script>

<style scoped>
.form-label {
  @apply block text-gray-700 select-none;
}

.form-error {
  @apply text-red-500 text-sm mt-1;
}

.btn-secondary {
  @apply bg-gray-100 text-gray-700 px-4 py-2 rounded hover:bg-gray-200 transition-colors;
}

.btn-primary {
  @apply bg-indigo-600 text-white px-6 py-2 rounded hover:bg-indigo-700 transition-colors;
}
</style>
